const adjectives = ['Dreamy', 'Creative', 'Mystic', 'Artistic', 'Cosmic', 'Fantasy', 'Magical', 'Wonder'];
const nouns = ['Artist', 'Creator', 'Muse', 'Dreamer', 'Vision', 'Spirit', 'Mind', 'Soul'];

export const generateUsername = () => {
  const adj = adjectives[Math.floor(Math.random() * adjectives.length)];
  const noun = nouns[Math.floor(Math.random() * nouns.length)];
  const num = Math.floor(Math.random() * 9999);
  return `${adj}${noun}${num}`;
};